<template>
  <div class="activities">
    <div class="banner">
      <img width="100%" src="../assets/Website_banner.webp" alt="" />
    </div>
    <h2 class="title">{{ $t("home.home_activities") }}</h2>
    <p class="remark">{{ $t("home.home_activities") }}</p>
    <div class="buttons">
      <div
        @click="
          team_id = '';
          yearBtn(item.value);
        "
        :class="[
          'btn-box',
          {
            'active-schedule': btnActive.year === item.value
          }
        ]"
        v-for="(item, index) in btnList"
        :key="index"
      >
        {{ item.year }}
      </div>
      <div class="select" :class="{ 'option-f': headType === '2' }">
        <el-select
          clearable
          :popper-append-to-body="false"
          :no-data-text="$t('home.nodata')"
          v-model="team_id"
          :placeholder="$t('schedule.select')"
          @change="getActivities()"
        >
          <el-option
            v-for="item in teamsInfo"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <p class="team-name">
              {{ item.name }}
            </p>
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-if="activitiesList.length > 0" v-loading="activitiesLoadig">
      <div
        class="contents"
        v-for="(item, index) in activitiesList"
        :key="index"
      >
        <div class="img-box">
          <img class="img" :src="item.abbr_photo_path_url" alt="" />
        </div>
        <div class="text">
          <p class="text-date">{{ item.date }}</p>
          <p class="text-title">{{ item.title }}</p>
          <p class="istext">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="coming">{{ $t("home.nodata_2") }}</p>
    </div>
  </div>
</template>

<script>
import { BasketballApi } from "../api/basketball";
import { mapState } from "vuex";

export default {
  data() {
    return {
      yearvalue: 11,
      yearList: [
        { label: "team1", value: 11 },
        { label: "team2", value: 12 },
        { label: "team3", value: 13 }
      ],
      watchImg: window.localStorage.getItem("watchImg") || 0,
      activitiesLoadig: true,
      title_en: "Learning Experience Activities",
      title_cn: "學習經歷活動",
      text_en: "(10 accumulated participation hours per student annually)",
      text_cn: "(每名學生全年共參與10小時）",
      activitiesList: [],
      btnActive: { year: "2024" },
      btnList: [
        { year: "2024-2025", value: "2024" },
        { year: "2023-2024", value: "2023" },
        { year: "2022-2023", value: "2022" },
        { year: "2021-2022", value: "2021" },
        { year: "2020-2021", value: "2020" }
      ],
      teamsInfo: [],
      team_id: ""
    };
  },
  watch: {
    headType() {}
  },
  computed: {
    ...mapState(["headType"])
  },
  methods: {
    TeamInfo() {
      this.activitiesLoadig = true;
      BasketballApi.getTeams({
        year: this.btnActive.year,
        type: this.headType === "1" ? "m" : "w"
      }).then((result) => {
        this.teamsInfo = result;
        this.teamsInfo.unshift({ id: "", name: "All" });
        this.activitiesLoadig = false;
      });
    },
    yearBtn(value) {
      this.btnActive.year = value;
      this.getActivities();
      this.TeamInfo();
    },
    getActivities() {
      this.activitiesLoadig = true;
      const data = {
        year: this.btnActive.year,
        team_id: this.team_id
      };
      BasketballApi.getActivities(data).then((res) => {
        this.activitiesList = res;
        this.activitiesLoadig = false;
      });
    }
  },
  created() {
    this.getActivities();
    this.TeamInfo();
  }
};
</script>
<style lang="scss">
.select {
  // height: 130px;
  margin-bottom: 0px;
  // border-bottom: 2px solid #eff1f7;
  .el-select {
    // margin: 40px 50px 0 0;
    width: 203px;
    border: none;
    // float: right;
    .el-input {
      .el-select__caret {
        color: #318bc8;
      }
      .el-input__inner {
        height: 37px;
        border: 1px solid #318bc8;
        border-radius: 15px;
        color: #318bc8 !important;
      }
    }
    .el-select-dropdown__item.selected {
      color: #318bc8;
    }
    .team-name {
      text-align: left;
    }
  }
}
.option-f {
  .el-select {
    .el-input {
      .el-select__caret {
        color: #b9a2c9;
      }
      .el-input__inner {
        border: 1px solid #b9a2c9;
        border-radius: 14.5px;
        color: #b9a2c9 !important;
      }
    }
    .el-select-dropdown__item.selected {
      color: #b9a2c9;
    }
  }
}
</style>
<style lang="scss" scoped>
.activities {
  text-align: left;
  .title {
    margin-top: 30px;
    color: #a9d36f;
  }
  .remark {
    font-size: 13px;
  }
  .buttons {
    display: flex;
    margin: 30px 0;
    .btn-box {
      padding: 10px 20px;
      background: #fafafa;
      margin-right: 10px;
      transition: all 0.6s;
      border-radius: 5px;
      cursor: pointer;
    }
    .btn-box:hover {
      background: #f4f4f4;
    }
    .active-schedule {
      background: #c6c3c3;
    }
  }
  .contents {
    display: flex;
    width: 80%;
    margin-bottom: 40px;
    .img-box {
      background: #f4f4f4;
      // width: 200px;
      width: 20%;
      height: 200px;
      padding: 5px;
      border-radius: 5px;
      .img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        object-position: center;
        object-fit: cover;
      }
    }
    .text {
      margin-left: 4%;
      width: 80%;
      .text-date {
        color: #5e98ca;
        margin-bottom: 15px;
      }
      .text-title {
        margin-bottom: 15px;
      }
      .istext {
        font-size: 13px;
      }
    }
  }
  .coming {
    color: #c9c9c9;
    font-size: 25px;
  }
}
@media screen and (max-width: 768px) {
  .activities {
    width: 95%;
    margin-left: 2.5%;
    .contents {
      flex-direction: column;
      width: 100%;
      .img-box {
        width: 100%;
      }
      .text {
        width: 100%;
        margin-top: 20px;
        margin-left: 0;
      }
    }
  }
}
</style>
